export const appendIchilovQuery = (path) => {
    const query = new URLSearchParams(window.location.search);
    const includesIchilov = query.has("ichilov");
   return includesIchilov ? `${path}?ichilov=true` : path;
};

export const hasIchilovQuery = () => {
    const query = new URLSearchParams(window.location.search);
    return query.has("ichilov")
};

